var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapterra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 107.654 42.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21024",
    "data-name": "Group 21024",
    transform: "translate(-289 -767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21015",
    "data-name": "Group 21015",
    transform: "translate(301 797.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010",
    transform: "translate(72.928 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ececec",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21014",
    "data-name": "Group 21014",
    transform: "translate(54.696 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-2",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-2",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-2",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_2",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-2",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-2",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011",
    transform: "translate(36.464 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-3",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-3",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-3",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_3",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-3",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-3",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012",
    transform: "translate(18.232 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-4",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-4",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-4",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_4",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-4",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-4",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21013",
    "data-name": "Group 21013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-5",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-5",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-5",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_5",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-5",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-5",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#ffc813",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21018",
    "data-name": "Group 21018",
    transform: "translate(6.654)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Capterra",
    transform: "translate(348 785)",
    fill: "#034c7f",
    fontSize: 19,
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.59,
    y: 0
  }, "Capterra")), /*#__PURE__*/React.createElement("g", {
    id: "Group_21017",
    "data-name": "Group 21017",
    transform: "translate(0 3.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36782",
    "data-name": "Path 36782",
    d: "M2118.817-5459.192l6.685-2.851-6.685,22Z",
    transform: "translate(-1821.875 6226)",
    fill: "#68c5ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36783",
    "data-name": "Path 36783",
    d: "M2104.346-5453.811l14.6-5.409v5.409Z",
    transform: "translate(-1822 6226.025)",
    fill: "#ff9d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36784",
    "data-name": "Path 36784",
    d: "M2113.351-5453.856l5.541,13.743v-13.743Z",
    transform: "translate(-1821.949 6226.07)",
    fill: "#044d80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36785",
    "data-name": "Path 36785",
    d: "M2114.872-5450.3l-10.5-3.612h9.056Z",
    transform: "translate(-1822 6226.123)",
    fill: "#e54747"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapterra);
export default __webpack_public_path__ + "static/media/capterra.e2f61471db490950815037d1af62c881.svg";
export { ForwardRef as ReactComponent };